module.exports = __webpack_public_path__ + "static/media/tooltip-warning-icon.c15d4f8f.svg";